import React from "react";
import "../styles/Iframe.css";

const Iframe = ({ data }) => {
  return (
    <div className="iframe-container text-center mx-auto max-w-6xl xs:px-4 pt-24">
      <h1 className="mt-10 text-5xl xs:text-2xl pb-4">{data.title}</h1>
      <p className="text-lg">{data.description}</p>
      <iframe
        src={data.src}
        title="G Tapp Onboarding"
        frameBorder="0"
        width="100%"
        height="600"
        allow="geolocation *; camera *"
        allowFullScreen
      ></iframe>
      <p className="text-xl mt-3 text-[#767676]">{data.disclosure}</p>
    </div>
  );
};

export default Iframe;
